﻿import * as React from 'react';
import {Box} from "@mui/system";
import {Button, Typography, Alert} from "@mui/material";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import * as actions from "../showcaseHandling/actions/ShowcaseOrderActions";
import {useEffect} from "react";
import showcaseOrderApi from "./ShowcaseOrderApi";

type ShowcaseProccessingPageProps = {
    orderId: number;
    actions: IActions;
    showcaseOrder: any;
}

const ShowcaseProccessingPage = (props: ShowcaseProccessingPageProps) => {
    const {showcaseOrder} = props;
    const {showcaseUrl} = window.appConfig;

    const redirectOnClick = async () => {
        if (showcaseOrder) {
            var response = await showcaseOrderApi.getProfileSettings(props.orderId)
            if (response){
                var responseObject = JSON.stringify(response);
                var data = Buffer.from(responseObject).toString('base64');
                if (data && (response.brokerFirmFileSettings === null &&  response.brokerChainFileSettings === null)){
                    window.open(showcaseUrl+'/edit/' + showcaseOrder.text +'?objectType=' + showcaseOrder.showcaseObjectType)
                }
                else{
                    window.open(showcaseUrl+'/edit/' + showcaseOrder.text +'?objectType=' + showcaseOrder.showcaseObjectType+'&data='+data);
                }
            }
           
        }
    }
    useEffect(() => {
        props.actions.getShowcaseOrder(props.orderId)
    }, [])
    
    return (
        <Box>
            <Alert variant="filled" severity="info" sx={{
                '& .MuiAlert-message': {
                    width: '100%'
                },
                alignItems: 'center',
            }}
            >
                <Box sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                        <Typography sx={{color: '#FFFFFF',}}>
                            Morgondagens marknadsmaterial! Digitala presentationer ger mer än text och bild -
                            utforska och förälska dig.
                        </Typography>
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        justifySelf: 'flex-end'
                    }}>
                        <Button variant="outlined" onClick={redirectOnClick} sx={{
                            color: '#FFFFFF',
                            borderColor: '#FFFFFF',
                            '&:hover': {borderColor: '#FFFFFF'}
                        }}>
                            Testa kostnadsfritt
                        </Button>
                    </Box>
                </Box>
            </Alert>
        </Box>
    );
}
function mapStateToProps(state: any, ownProps: ShowcaseProccessingPageProps) {
    return {
        showcaseOrder: state.showcaseOrder,
    };
}
function mapDispatchToProps(dispatch: any, ownProps: ShowcaseProccessingPageProps): { actions: IActions } {
    return {
        actions: {
            getShowcaseOrder: (orderId) => dispatch(actions.getShowcaseOrder(orderId))
        }
    };
}
interface IActions {
    getShowcaseOrder: (orderId: number) => Promise<any>;
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShowcaseProccessingPage));
